import React from 'react';
import {PropTypes} from 'prop-types';
import {observer} from 'mobx-react';

@observer
export default class LoadingOverlayWithCancel extends React.Component {

  static propTypes = {
    show: PropTypes.bool,
    cancel: PropTypes.func.isRequired,
    actionText: PropTypes.string,
    buttonText: PropTypes.string
  };

  static defaultProps = {
    actionText: 'Saving',
    buttonText: 'Cancel'
  }

  constructor(props) {
    super(props);
    this.cancelIsFocused = false;
  }

  componentDidUpdate() {
    if (this.props.show) {
      this.dummyButton.focus();
      this.cancelIsFocused = false;
    }
  }

  onCancel = () => {
    this.props.cancel();
  };

  onFocus = () => {
    this.cancelIsFocused = false;
  };

  onKeyDown = (event) => {
    if (event.keyCode == 9) {
      event.preventDefault();
      if (this.cancelIsFocused) {
        this.dummyButton.focus();
      } else {
        this.cancelButton.focus();
      }
      this.cancelIsFocused = !this.cancelIsFocused;
    }
  };

  render() {
    return (<div className={`loading-overlay ${this.props.show
        ? 'show'
        : ''}`}>
      <h3>{this.props.actionText}...</h3>
      <p>This may take a few moments.</p>
      <div className="submit-loading-spinner">
        {
          new Array(8).fill('').map((elem, idx) => {
            return (<div key={idx}></div>)
          })
        }
      </div>
      {/* <button onFocus={this.onFocus} onKeyDown={this.onKeyDown} ref={i => this.cancelButton = i} className="btn fn-cancel" onClick={this.onCancel}>
        {this.props.buttonText}
      </button> */}
      <button aria-hidden="true" onKeyDown={this.onKeyDown} className="dummy-button" ref={i => this.dummyButton = i} />
    </div>)
  }
}
